export var Action = /*#__PURE__*/function (Action) {
  Action["CLICKED"] = "clicked";
  Action["RETRIEVE_FAILED"] = "retrieveFailed";
  Action["RETRIEVED"] = "retrieved";
  Action["SELECTED"] = "selected";
  Action["VIEWED"] = "viewed";
  return Action;
}({});
export var ActionSubject = /*#__PURE__*/function (ActionSubject) {
  ActionSubject["BUTTON"] = "button";
  ActionSubject["AUTOCOMPLETE_OPTION"] = "autocompleteOption";
  ActionSubject["ERROR_MESSAGE"] = "errorMessage";
  return ActionSubject;
}({});
export var ActionSubjectId = /*#__PURE__*/function (ActionSubjectId) {
  ActionSubjectId["EDITOR_EXPAND"] = "jqlEditorExpand";
  ActionSubjectId["EDITOR_SEARCH"] = "jqlEditorSearch";
  ActionSubjectId["EDITOR_HELP"] = "jqlEditorHelp";
  ActionSubjectId["JQL_RESULT"] = "jqlResult";
  return ActionSubjectId;
}({});